import { Box, TableHead, TablePagination } from '@mui/material';
import { useCompanyPlanContext } from 'FeatureModules/Auth/Contexts/CompanyPlanContext';
import { PaginationContainer } from 'Components/TableBase/Pagination';
import SortableTableHead from 'Components/TableBase/SortableTableHead';
import { StyledTable, StyledTableBody } from 'Components/TableBase/Table';
import React, { FC, useState } from 'react';
import { IPartnerRequest } from 'FeatureModules/Partner/types/partner.types';
import {
  REQUEST_HEADER_COLUMNS,
  REQUEST_HEADER_PARTNER_COLUMNS,
} from '../../../Document/utils/documentRequestColumns';
import RequestGroupTableRow from './RequestGroupTableRow';
import { ECustomerPlan } from 'FeatureModules/Auth/types/company.types';

export enum ERequestsTableAction {
  'MANAGE',
  'DELETE',
  'DISMISS',
  'DISMISS_EDIT',
  'ACCEPT',
  'ADD_CLAIM',
  'EDIT',
  'SEE_DETAILS',
  'REVIEW',
}

export interface IRequestsTableProps {
  'data-testId'?: string;
  requests: IPartnerRequest[];
  selectedIds?: string[];
  hideHeader?: boolean;
  rowsPerPage: number;
  onRequestClick?: (id: string) => void;
  onActionClick: (id: string, action: ERequestsTableAction) => void;
}

const PaginatedRequestsTable: FC<IRequestsTableProps> = ({
  'data-testId': dataCy = 'requested-documents-table-body',
  requests,
  hideHeader,
  rowsPerPage,
  onActionClick,
  onRequestClick,
}) => {
  const { plan } = useCompanyPlanContext();
  const isPartner = plan === ECustomerPlan.FREEMIUM;

  const [currentPage, setCurrentPage] = useState<number>(0);

  const isPaginated = requests.length > rowsPerPage;

  return (
    <Box position="relative">
      <StyledTable aria-labelledby="tableTitle" aria-label="enhanced table">
        {hideHeader ? (
          <TableHead />
        ) : (
          <SortableTableHead
            headerColumns={isPartner ? REQUEST_HEADER_PARTNER_COLUMNS : REQUEST_HEADER_COLUMNS}
            multiselect={false}
          />
        )}

        <StyledTableBody>
          {requests
            .slice(currentPage * rowsPerPage, currentPage * rowsPerPage + rowsPerPage)
            .map(request => (
              <RequestGroupTableRow
                key={request.id}
                isPartner={isPartner}
                request={request}
                onRequestClick={onRequestClick}
                onActionClick={onActionClick}
              />
            ))}
        </StyledTableBody>
      </StyledTable>
      {isPaginated && (
        <PaginationContainer>
          <TablePagination
            component="div"
            rowsPerPageOptions={[]}
            count={requests.length}
            rowsPerPage={rowsPerPage}
            page={currentPage}
            onPageChange={(e, page) => setCurrentPage(page)}
            labelDisplayedRows={({ page }) =>
              `Page ${page + 1} of ${Math.ceil(requests.length / rowsPerPage)}`
            }
          />
        </PaginationContainer>
      )}
    </Box>
  );
};

export default PaginatedRequestsTable;
